module.exports = __webpack_public_path__ + "static/media/mini.25700c54.png";


//////////////////
// WEBPACK FOOTER
// ./src/marketingOnline/data/carImages/远程E5L/mini.png
// module id = 726
// module chunks = 0